export default "__VITE_ASSET__DNJzu9hG__"